// export const API_Address = "http://localhost:5000/"; // Not used, see setupProxy.js instead.
export const VT_HOST = "report.vtmarkets.com.cn";
